import ReactPlayer from 'react-player';
import Box from '@mui/material/Box';
import { VideoPlayerProps } from '../../types/videos';

export const MuxVideoPlayer = ({ video }: { video: VideoPlayerProps }) => {
  let aspectRatio = '16 / 9';
  switch (video.format) {
    case 'vertical':
      aspectRatio = '9 / 16';
      break;
    case 'horizontal':
      aspectRatio = '16 / 9';
      break;
    case 'square':
      aspectRatio = '1 / 1';
      break;
    default:
      console.log('>>> unknown format: ', video.format, ' - using default: 16 / 9');
  }

  return (
    <Box sx={{
      aspectRatio: aspectRatio,
      margin: '0 auto',
      backgroundColor: '#ccc'
    }} data-preview-uri={video.preview_uri}>
      <ReactPlayer
        key="mux"
        url={video.media_id ? `https://stream.mux.com/${video.media_id}.m3u8` : video.preview_uri}
        controls
        width={'100%'}
        height={'100%'}
        style={{ marginLeft: 'auto', marginRight: 'auto' }}
      />
    </Box>
  );
};
